import React from 'react';
import { motion } from 'framer-motion';

const ServicesProcess: React.FC = () => {
  const processSteps = [
    {
      number: 1,
      title: 'Discovery',
      description: 'We begin by understanding your vision, goals, and target audience. Through in-depth consultations, we identify your unique story and the best way to communicate it effectively.'
    },
    {
      number: 2,
      title: 'Planning',
      description: 'Our team develops a comprehensive strategy and creative concept tailored to your needs. We create detailed timelines, budgets, and production plans to ensure smooth execution.'
    },
    {
      number: 3,
      title: 'Production',
      description: 'With meticulous attention to detail, we bring your vision to life. Our experienced team handles all aspects of production, from filming to editing, ensuring the highest quality output.'
    },
    {
      number: 4,
      title: 'Delivery',
      description: 'We deliver your final product on time and exceed expectations. Our commitment extends beyond delivery with ongoing support to help you maximize the impact of your content.'
    }
  ];

  return (
    <section className="py-20 md:py-32 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 
            className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold mb-6"
            style={{ 
              fontFamily: "'Montserrat', sans-serif",
              color: '#EF3F23',
              letterSpacing: '-0.05em'
            }}
          >
            Our Process
          </h2>
          <p 
            className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            We follow a structured approach to ensure your project's success. From initial concept to final delivery, we work closely with you every step of the way to create content that resonates with your audience and achieves your objectives.
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 max-w-7xl mx-auto">
          {processSteps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.15 }}
              className="relative"
            >
              {/* Connecting Line (hidden on mobile, shown on larger screens) */}
              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-[#EF3F23] opacity-30" style={{ width: 'calc(100% - 4rem)', left: 'calc(100% - 2rem)' }}></div>
              )}
              
              <div className="text-center h-full flex flex-col">
                <div className="w-24 h-24 rounded-full mx-auto mb-6 flex items-center justify-center text-3xl font-bold text-white border-4 border-[#EF3F23]" style={{ backgroundColor: '#EF3F23' }}>
                  {step.number}
                </div>
                <h3 
                  className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4"
                  style={{ 
                    fontFamily: "'Montserrat', sans-serif",
                    color: '#EF3F23',
                    letterSpacing: '-0.05em'
                  }}
                >
                  {step.title}
                </h3>
                <p 
                  className="text-base md:text-lg text-gray-300 leading-relaxed flex-grow"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesProcess;
